import { setDefaultFiltersBeforeEnter } from 'asteroid'

export default [
  {
    name: 'ManagementReportsList',
    path: '/management-reports',
    component: () => import('pages/management-reports/ManagementReportsList.vue')
  },
  {
    name: 'ManagementReportsGlobalList',
    path: '/management-reports/global',
    beforeEnter: setDefaultFiltersBeforeEnter,
    component: () => import('pages/management-reports/global/ManagementReportsGlobalList.vue')
  },
  {
    name: 'ManagementReportsSalesProductsList',
    path: '/management-reports/sales-products',
    component: () => import('pages/management-reports/sales-products/ManagementReportsSalesProductsList.vue')
  },
  {
    name: 'ManagementReportsBlueprintsList',
    path: '/management-reports/blueprints',
    component: () => import('pages/management-reports/blueprints/ManagementReportsBlueprintsList.vue')
  },
  {
    name: 'ManagementReportsApprovalsList',
    path: '/management-reports/approvals',
    component: () => import('pages/management-reports/approvals/ManagementReportsApprovalsList.vue')
  },
  {
    name: 'ManagementReportsCommissionsList',
    path: '/management-reports/commissions',
    component: () => import('pages/management-reports/commissions/ManagementReportsCommissionsList.vue')
  },
  {
    name: 'ManagementReportsParcelFlowList',
    path: '/management-reports/parcel-flow',
    component: () => import('pages/management-reports/parcel-flow/ManagementReportsParcelFlowList.vue')
  },
  {
    name: 'ManagementReportsPaymentFlowList',
    path: '/management-reports/payment-flow',
    component: () => import('pages/management-reports/payment-flow/ManagementReportsPaymentFlowList.vue')
  },
  {
    name: 'ManagementReportsPersonalizationsList',
    path: '/management-reports/personalizations',
    component: () => import('pages/management-reports/personalizations/ManagementReportsPersonalizationsList.vue')
  }
]
